"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTooltip = exports.EntityTooltipDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_link_value_1 = require("./entity-link-value");
var content_node_1 = require("./content-node");
var coalesce_1 = require("../../utils/coalesce");
var cn_1 = require("../../utils/cn");
var cls = (0, cn_1.classNames)('entity-tooltip');
exports.EntityTooltipDefaultProps = {
  showDescription: true
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    padding: ", ";\n    a {\n      text-decoration: none;\n      color: ", " !important;\n\n      &:hover {\n        color: ", " !important;\n      }\n    }\n  "], ["\n    font-family: ", ";\n    padding: ", ";\n    a {\n      text-decoration: none;\n      color: ", " !important;\n\n      &:hover {\n        color: ", " !important;\n      }\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.UNIT(4), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('primary'))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-decoration: none;\n    font-size: ", ";\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "], ["\n    text-decoration: none;\n    font-size: ", ";\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.UNIT(3), theme_1.theme.COLOR('text'))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Link: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
var EntityTooltip = function (props) {
  var className = props.className,
    entity = props.entity,
    children = props.children,
    showDescription = props.showDescription,
    footer = props.footer,
    valueProps = __rest(props, ["className", "entity", "children", "showDescription", "footer"]);
  var description = (0, coalesce_1.coalesce)(entity, ['description', 'openGraph.description']);
  var hasDescription = showDescription && description && description.text;
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Link, __assign({}, valueProps, {
    entity: entity
  })), children, hasDescription && react_1.default.createElement(My.Description, {
    className: cls.sub('description'),
    entity: description
  }), footer);
};
exports.EntityTooltip = EntityTooltip;
exports.EntityTooltip.cls = cls;
exports.EntityTooltip.defaultProps = exports.EntityTooltipDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;